import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { loading } from 'owa-timestream-search-store';
import { searching } from 'owa-locstrings/lib/strings/searching.locstring.json';
import loc from 'owa-localize';
import showingResults from '../selectors/showingResults';

export default observer(function Loading() {
    if (!loading() || showingResults()) {
        return null;
    }

    return <div className={styles.searchLabel}>{loc(searching)}</div>;
});
